import moment from 'moment';
import ConfigData from '@/configs/ConfigData';

const Block = {
  namespaced: true, // Use namespaced to separate scope
  state: {
    attempts: 0,
    isBlocked: false,
    blockEndTime: null, // Use moment().toISOString() to store time
  },
  mutations: {
    incrementAttempts(state) {
      state.attempts += 1;
    },
    resetAttempts(state) {
      state.attempts = 0;
    },
    setBlocked(state, endTime) {
      state.isBlocked = true;
      state.blockEndTime = endTime; // Store endTime as ISO string
    },
    unBlock(state) {
      state.isBlocked = false;
      state.blockEndTime = null;
    },
  },
  actions: {
    handleAttempt({ commit, state, dispatch }) {
      if (state.isBlocked) {
        const remainingTime = moment(state.blockEndTime).diff(moment(), 'milliseconds');
        if (remainingTime <= 0) {
          dispatch('unBlock'); // Unblock if the time is up
        }
        return;
      }

      commit('incrementAttempts');

      if (state.attempts >= ConfigData.RATE_LIMIT_MAX_REQUEST) {
        const blockDuration = ConfigData.RATE_LIMIT_MINUTE_WAIT * 60 * 1000; // 3 minute in milliseconds
        const endTime = moment().add(blockDuration, 'milliseconds').toISOString();

        commit('setBlocked', endTime);

        // Set timeout to unblock
        setTimeout(() => {
          dispatch('unBlock');
        }, blockDuration);
      }
    },
    unBlock({ commit }) {
      commit('unBlock');
      commit('resetAttempts');
    },
  },
  getters: {
    isBlocked: (state) => state.isBlocked && moment(state.blockEndTime).diff(moment(), 'milliseconds') > 0,
    remainingTime: (state) => {
      if (!state.blockEndTime) return 0;
      return Math.max(0, moment(state.blockEndTime).diff(moment(), 'seconds')); // Remaining time in seconds
    },
  },
};

export default Block;